import AiAgents from "../singleton/AIAgents";
import { AGENT_EVENTS, AGENT_EVENTS_EDITOR } from "../utils/agent-utils";
import { PROVIDERS } from "../utils/openAI-utils";

AFRAME.registerComponent("ai-agent", {
  schema: {
    aiName: { type: "string", default: "" },
    provider: { type: "string", default: "OpenAI" },
    assistant: { type: "string" },
    model: { type: "string", default: "" },
    endpoint: { type: "string", default: "" },
    apiKey: { type: "string", default: "" },
    inputType: { type: "string", default: "text" },
    encrypted: { type: "boolean", default: false },
    enableOnProximity: { type: "boolean", default: false },
    proximityRadius: { type: "number", default: 3 },
    userPrompts: { type: "boolean", default: false },
    welcomeText: { type: "string", default: "" },
    welcomeTextUrl: { type: "string", default: "" },
    emitEvents: { type: "boolean", default: false },
    voiceSpeechStrategy: { type: "string", default: "WebAPI" },
    leaveColliderText: { type: "string", default: "" },
    systemPrompt: { type: "string", default: "" } // Add systemPrompt to schema
  },
  init() {
    this.npcId = "";
    this.apiKey = this.data.apiKey;
    // this.mixerEl = findAncestorWithComponent(this.el, "animation-mixer");
    this.el.addEventListener("ai-message", this.aiTalk.bind(this));
    this.el.addEventListener("ai-end", this.onEndAudio.bind(this));
    this.el.addEventListener(AGENT_EVENTS.AI_SPEAK, this.onSpeak.bind(this));
    this.el.addEventListener(AGENT_EVENTS.AI_THINKING, this.onThinking.bind(this));
    this.el.addEventListener(AGENT_EVENTS.AI_FINISH_SPEAK, this.onFinishSpeak.bind(this));
    this.el.addEventListener(AGENT_EVENTS.AI_TALKING_FRAME, this.onTalking.bind(this));

    this.messageDispatch = window.APP.messageDispatch;
    this.threadId = null;
    this.audioEl = AFRAME.scenes[0].systems["npc-audio"].audioEl;
    this.el.appendChild(this.audioEl);
    this.assistantId = this.data.assistant;
    this.speakerBotUI = null;
    this.isTalking = false;
    this.recording = false;

    this.id = AiAgents.generateRandomId();
    this.objectUuid = this.el.object3D.uuid; // Get the object3D UUID

    if (this.data.enableOnProximity) {
      this.el.setAttribute("ai-proximity-audio", { distance: this.data.proximityRadius });
    }

    AiAgents.registerAgent({
      id: this.id,
      name: this.data.aiName,
      apiKey: this.data.apiKey,
      assistantId: this.data.assistant,
      model: this.data.model,
      endpoint: this.data.endpoint,
      inputType: this.data.inputType,
      encrypted: this.data.encrypted,
      enableOnProximity: this.data.enableOnProximity,
      proximityRadius: this.data.proximityRadius,
      el: this.el,
      objectUuid: this.objectUuid,
      welcomeText: this.data.welcomeText,
      welcomeTextUrl: this.data.welcomeTextUrl,
      voiceSpeechStrategy: this.data.voiceSpeechStrategy,
      provider: this.data.provider || PROVIDERS.OPEN_AI_ASSISTANT,
      systemPrompt: this.data.systemPrompt // Pass systemPrompt to registerAgent
    });
  },
  update() {
    this.npcId = this.data.name;
    this.apiKey = this.data.apiKey;
  },
  onSpeak() {
    if (!this.data.emitEvents) return;
    this.el.object3D.dispatchEvent({
      type: AGENT_EVENTS_EDITOR.ON_AGENT_TALK_START,
      detail: { data: this.data }
    });
  },
  onThinking() {
    if (!this.data.emitEvents) return;
    this.el.object3D.dispatchEvent({
      type: AGENT_EVENTS_EDITOR.ON_AGENT_THINKING,
      detail: { data: this.data }
    });
  },

  onFinishSpeak() {
    if (!this.data.emitEvents) return;
    this.el.object3D.dispatchEvent({
      type: AGENT_EVENTS_EDITOR.ON_AGENT_TALK_END,
      detail: { data: this.data }
    });
  },

  async aiTalk(event) {
    if (!event || !event.detail) return;
    const { body: aiMessage, audio, messageDispatch, voiceMode, id, play, loadingAudio, playable } = event.detail;

    if (messageDispatch !== false) {
      this.aiSendPrivateMessage(aiMessage, audio, voiceMode, id, play, loadingAudio, playable);
    }

    // handle image
    // if(voiceMode && aiMessage.startsWith('https') && !audio) {
    //   const showImageAudio = "https://nextrealitydigital.blob.core.windows.net/nrd/metaverse/here-is-theresult.mp3";
    //   await this.renderImageUser(aiMessage);
    //   this.playAnyAudio(showImageAudio);
    // }

    // if(aiMessage.startsWith('https') || !audio) {
    //   return;
    // }

    // if(voiceMode) {
    //   this.mixerEl?.components["animation-mixer"].setPausedComponent(false);
    //   this.el.setAttribute("loop-animation", { paused: false });
    //   await new Promise((resolve, reject) => setTimeout(resolve, 100));
    //   await this.playSpeak(audio);
    // }
  },
  aiSendPrivateMessage(aiMessage, audio, voiceMode, id, play, loadingAudio, playable) {
    const type = "private-chat";
    // let play = !!audio;
    // if(isIOS()) {
    //   play = false;
    // }

    // if(!voiceMode) {
    //   play = false;
    // }

    this.messageDispatch.dispatchEvent(
      new CustomEvent("ai-local-message-edit", {
        detail: {
          type: type,
          body: {
            message: aiMessage,
            receiver: this.npcId,
            sender: this.data.name,
            play,
            audio,
            groupId: id,
            loadingAudio,
            playable
          }
        }
      })
    );
  },
  onEndAudio() {
    const audioEl = this.audioEl;
    if (audioEl) {
      // if(!this.el.components["loop-animation"].data.paused) {
      //   // this.mixerEl?.components["animation-mixer"].setPausedComponent(true);
      //   // this.el.components["loop-animation"].stopAnimation();
      // }
      audioEl.pause();
      this.messageDispatch.dispatchEvent(new CustomEvent("ai-cancel-play"));
    }

    const timeForNextPrompt = 2000; // 2 seconds
    setTimeout(() => {
      this.isTalking = false;
      // window.dispatchEvent(new CustomEvent(AGENT_EVENTS.AI_FINISH_SPEAK));
    }, timeForNextPrompt);
  },

  async playSpeakWelcome() {
    // if(AiAgents.status === "talking" || AiAgents.status === "thinking") return;
    if (this.data.welcomeText && this.data.userPrompts) {
      AiAgents.cancelCurrentPrompt({ id: this.id, el: this.el });
      // AiAgents.setMyLocalMessageTranscribed({
      //   messageTranscribed: this.data.welcomeText,
      //   receiver: this.id,
      //   mySessionId: window.mySessionId
      // })
      const agent = AiAgents.getAgentById(this.id);
      AiAgents.setAILoadingMessage(this.id);
      await new Promise(resolve => setTimeout(resolve, 100));
      const AILastMessage = window.getAILastMessage(this.id);
      if (AILastMessage) {
        await AiAgents.sendPrompt({
          message: this.data.welcomeText,
          agent: agent,
          messageId: AILastMessage.id,
          enableSpeech: true
        });
      }
    }
  },
  async playLeaveText() {
    if (this.data.userPrompts && this.data.leaveColliderText) {
      AiAgents.cancelCurrentPrompt({ id: this.id, el: this.el });
      // AiAgents.setMyLocalMessageTranscribed({
      //   messageTranscribed: this.data.leaveColliderText,
      //   receiver: this.id,
      //   mySessionId: window.mySessionId
      // })
      const agent = AiAgents.getAgentById(this.id);
      AiAgents.setAILoadingMessage(this.id);
      await new Promise(resolve => setTimeout(resolve, 10));
      const AILastMessage = window.getAILastMessage(this.id);
      AiAgents.sendPrompt({
        message: this.data.leaveColliderText,
        agent: agent,
        messageId: AILastMessage.id,
        enableSpeech: true
      });

      // setTimeout(() => {
      //   AiAgents.sendPrompt({
      //     message: this.data.leaveColliderText,
      //     agent: agent,
      //     messageId: AILastMessage.id
      //   });
      // }, 2000)
    }
  },
  onProximityEnter() {
    if (this.data.emitEvents) {
      this.el.object3D.dispatchEvent({
        type: AGENT_EVENTS_EDITOR.ON_USER_ENTER,
        detail: { data: this.data }
      });
    }
    this.playSpeakWelcome();
  },
  onProximityLeave() {
    this.playLeaveText();
    if (!this.data.emitEvents) return;
    this.el.object3D.dispatchEvent({
      type: AGENT_EVENTS_EDITOR.ON_USER_LEAVE,
      detail: { data: this.data }
    });
  },
  onTalking(e) {
    this.el.object3D.dispatchEvent({
      type: AGENT_EVENTS_EDITOR.ON_AGENT_TALKING,
      amplitude: e.detail.amplitude
    });
  }
});
